import {BaseFilterModel} from "./baseFilter.model";

export class SessionFilter extends BaseFilterModel {
    userName = '';
    userRole = '';
    id = '';
}